import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconActivateFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M27.73 4.27a.92.92 0 0 1 .235.907l-4.924 17.23a.92.92 0 0 1-.634.634l-17.23 4.924a.923.923 0 0 1-1.141-1.142l4.923-17.23a.92.92 0 0 1 .634-.634l17.23-4.923a.92.92 0 0 1 .907.234M13.077 16a2.923 2.923 0 1 1 5.846 0 2.923 2.923 0 0 1-5.846 0" clipRule="evenodd" /></svg>;
export default SvgIconActivateFilledSmall;